import { Selector } from 'src/common/types';
import DataStore from 'src/core/stores/data-store';

export interface DefaultRoleSummary {
  id: string;
  name: string;
  partnersOnly: boolean;
  selector: Selector;
}

export class DefaultRoleSummaryStore extends DataStore<DefaultRoleSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/default-roles`, []);
  }
}
